import { ADMIN_BASE_BATH } from '@app/constants/variables';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import * as S from './ProfileOverlay.styles';

export const ProfileOverlay: React.FC = ({ ...props }) => {
  const { t } = useTranslation();

  return (
    <div {...props}>
      <S.Text>
        <Link to={`${ADMIN_BASE_BATH}/profile`}>{t('profile.title')}</Link>
      </S.Text>
      <S.ItemsDivider />
      <S.ItemsDivider />
      <S.Text>
        <Link to="/logout">{t('header.logout')}</Link>
      </S.Text>
    </div>
  );
};
